/**
 * The written family agreement. Kept as data so the Family screen and any
 * future printable version stay in sync, and so wording changes are one edit.
 */

export interface AgreementSection {
  id: string
  title: string
  intro?: string
  items: string[]
}

export const READY_RULE: AgreementSection = {
  id: 'ready',
  title: '"Ready for Tomorrow"',
  items: [
    'Daily responsibilities done + one household contribution = ready for tomorrow.',
    'A chore counts as done once a parent has checked it. Tick it when you’ve finished; a parent approves it, or sends it back if it needs another go.',
    'Once it’s done, it’s done. Nothing extra gets added on top.',
  ],
}

export const CONNECTION_RULE: AgreementSection = {
  id: 'connection',
  title: 'Connecting with family',
  items: ['At least one non-solo connection with family each week.'],
}

export const PLANS_RULE: AgreementSection = {
  id: 'plans',
  title: 'Plans',
  items: [
    'Communicate any extra-curricular plans ahead of time — going out with friends, having friends over, and so on.',
  ],
}

export const AGREEMENT_SECTIONS: AgreementSection[] = [READY_RULE, PLANS_RULE, CONNECTION_RULE]
